let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("e9VaU")).then(() => parcelRequire('k9qb8'));